// extracted by css-extract-rspack-plugin
export default {"leadWithImage":"lead-with-image--ZyfHh5e1SdA8XCYN","author":"author--XjMhNfdhY243K2bx","authorImage":"author-image--z2jYFAaMZlomQeL5"};